<script>
import {dateToString, getImagePath, loadModelRelations, truncate} from "@/helpers/utils";
import {Person} from "@/services/models";
import {formatAddress} from "@/helpers/inventories";
import PaginationLocal from "@/components/pagination-local.vue";
import VueEasyLightbox from "vue-easy-lightbox";
import PersonInline from "@/components/persons/person-inline.vue";
import Loader from "@/components/loader.vue";
import api from "@/services/api";

export default {
  components: {Loader, PersonInline, PaginationLocal, VueEasyLightbox},
  props: {
    person: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      correspondancesTotal: 0,
      pagesTotal: 0,
      inventoriesTotal: 0,
      drawingsTotal: 0,
      clickedPages: false,
      clickedInventories: false,
      clickedDrawings: false,
      pageFields: [
        {key: "NumPageAlbum", label: '#'},
        {key: "image", label: 'Image'},
        {key: "date"},
        {key: "address", label: 'Adresse'},
        {key: "persons", label: 'Personnes'},
        {key: "inscription_commentaire", label: 'Inscription / Commentaire', class: "w-50"},
      ],
      correspondenceFields: [
        {key: "code_correspondence", label: '#'},
        {key: "departure", label: 'Expéditeur'},
        {key: "destination", label: 'Destinataire'},
        {key: "date", label: 'Date'},
        {key: "subject", label: 'Sujet'},
        {key: "persons", label: 'Personnalité(s)'},
        {key: "letter_type", label: 'Type de lettre', class: "text-center"},
        {key: "actions", class: 'text-center'},
      ],
      inventoryFields: [
        {key: "inventory_number", label: 'Numéro d\'inventaire'},
        {key: "exploitation_number", label: 'Cote libre', class: 'text-center'},
        {key: "title", label: 'Titre'},
        {key: "date", label: 'Date'},
        {key: "authors", label: 'Auteur'},
        {key: "persons", label: 'Personne(s)'},
        {key: "format", class: 'text-center'},
        {key: "actions", class: 'text-center'},
      ],
      drawingFields: [
        {key: "inventory_number", label: 'Numéro d\'inventaire'},
        {key: "date", label: 'Date'},
        {key: "authors", label: 'Auteur'},
        {key: "persons", label: 'Personne(s)'},
        {key: "state", label: 'État'},
        {key: "actions", class: 'text-center'}
      ],
      notebookFields: [
        {key: "image", label: ''},
        {key: "filename", label: 'Fichier'},
        {key: "day", label: 'Jour'},
        {key: "month", label: 'Mois'},
        {key: "year", label: 'Année'}
      ],
      notebooks: [],
      notebooksCurrentPage: 1,
      notebooksTotalRows: 0,
      notebooksPerPage: 5,
      newspaperFields: [
        {key: "image", label: ''},
        {key: "filename", label: 'Fichier'}
      ],
      newspapers: [],
      loading: true,
      correspondences: [],
      inventories: [],
      drawings: [],
      currentPageNewspapers: 1,
      currentPageCorrespondences: 1,
      currentPageInventories: 1,
      currentPageDrawings: 1,
      currentPagePages: 1,
      singleImage: false,
      lightboxImgs: [],
    };
  },
  mounted() {
    if (!(this.person instanceof Person)) {
      this.person = new Person(this.person);
    }

    loadModelRelations(this.person, 'events.lafil014.notebook,events.newspaper').then(() => {
      for (const event of this.person.events) {
        if (event.lafil014.length === 0) {
          continue;
        }

        for (const lafil014 of event.lafil014) {
          if (lafil014.notebook) {
            this.notebooks.push(lafil014.notebook);
          }
        }
      }

      this.notebooks = this.notebooks.filter((obj1, i, arr) =>
          arr.findIndex(obj2 => (obj2.Code === obj1.Code)) === i
      );

      this.notebooksTotalRows = this.notebooks.length;

      for (const event of this.person.events) {
        if (event.newspaper) {
          this.newspapers.push(event.newspaper);
        }
      }

      this.newspapers = this.newspapers.filter((obj1, i, arr) =>
          arr.findIndex(obj2 => (obj2.id === obj1.id)) === i
      );

      this.loading = false;
    });
  },
  methods: {
    formatAddress,
    formatDate(date, date_end) {
      let dateFull = dateToString(date);

      if (date_end)
        dateFull += (dateFull !== '' ? ' - ' : '') + dateToString(date_end);

      return dateFull;
    },
    displaySubject(correspondence) {
      return truncate(correspondence.subject, 20, '...');
    },
    truncate(text, length, clamp) {
      return truncate(text, length, clamp);
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
    },
    getImagePathRoute(route, item, thumbnail = true) {
      try {
        return [{
          src: '/api/' + route + '/' + item.id + '/' + (thumbnail ? 'thumbnail' : 'image'),
          title: item.filename
        }];
      } catch (e) {
        return [{
          src: require(`@/assets/images/missing-img.svg`),
          title: 'missing-img'
        }];
      }
    },
    getImagePath(item, thumbnails) {
      return getImagePath(item, thumbnails);
    },
    showModel(v) {
      this.$emit('open', v.detail());
    },
    isBis(page) {
      if (!page.NumPageAlbum) {
        return false;
      }

      return page.NumPageAlbum.match(/bis|ter/i) !== null;
    },
    formatAdresse(item) {
      let adresse = '';

      if (item.Adresse !== '' && item.Adresse !== ' ')
        adresse += item.Adresse;
      if (item.Ville !== '' && item.Ville !== ' ')
        adresse += (adresse !== '' ? ' - ' : '') + item.Ville;
      if (item.Region !== '' && item.Region !== ' ')
        adresse += (adresse !== '' ? ' - ' : '') + item.Region;
      if (item.Pays !== '' && item.Pays !== ' ')
        adresse += (adresse !== '' ? ' - ' : '') + item.Pays;

      return adresse;
    },
    clickedImage(item) {
      this.lightboxImgs = item;
      this.singleImage = true;
    },
    provider(ctx, action) {
      const params = {
        page: ctx.currentPage,
        length: ctx.perPage
      };

      return api.get(`persons/${this.person.id}/${action}`, params).then((r) => {
        const items = r.data.data
        this[action + 'Total'] = r.data.total;

        return (items);
      }).catch(() => {
        return [];
      });
    },
    providerPages(ctx) {
      return this.provider(ctx, 'pages');
    },
    providerCorrespondances(ctx) {
      return this.provider(ctx, 'correspondances');
    },
    providerInventories(ctx) {
      return this.provider(ctx, 'inventories');
    },
    providerDrawings(ctx) {
      return this.provider(ctx, 'drawings');
    },
  },
};
</script>

<template>
  <b-card no-body class="text-center">
    <loader v-if="loading" :loading="loading"></loader>

    <template v-else>
      <span v-if="person.active === 0" class="badge-soft-danger">Personne désactivée</span>
      <b-card-body>
        <div v-if="!person.image" class="avatar-sm mx-auto mb-4">
              <span class="avatar-title rounded-circle bg-soft bg-primary text-primary font-size-16">
                {{ person.last_name.charAt(0) }}{{ person.first_name.charAt(0) }}
              </span>
        </div>
        <div v-if="person.image" class="mb-4">
          <img class="rounded-circle avatar-sm" :src="`${person.image}`" alt/>
        </div>
        <h5 class="font-size-15 mb-1">
          <span class="text-dark text-capitalize">{{ person }}</span>
        </h5>

        <div v-if="person.birth_date || person.death_date"></div>

        <div v-if="person.relatives">
          <span
              class="badge bg-primary font-size-11 m-1"
          >{{ person.relatives }}</span>
        </div>

        <p v-if="person.birth_name" class="text-muted"> né(e) {{ person.birth_name }}</p>

        <p class="text-muted text-capitalize" v-if="person.surname">alias <i
            class="bx bx-chevrons-left"></i>{{ person.surname }}<i
            class="bx bx-chevrons-right"></i></p>

        <p class="text-muted" v-if="person.birth_date || person.death_date">
          {{ formatDate(person.birth_date, person.death_date) }}
        </p>

        <blockquote class="blockquote" style="text-align: left" v-if="person.details">{{
            person.details
          }}
        </blockquote>

        <b-tabs class="mt-4" fill>
          <b-tab title="Correspondances" active no-body>
            <b-table :items="providerCorrespondances" :fields="correspondenceFields" responsive="sm" striped
                     sticky-header :per-page="10" head-variant="light" :current-page="currentPageCorrespondences">
              <template #table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>

              <template #cell(subject)="data">
                {{ displaySubject(data.item) }}
              </template>
              <template #cell(date)="data">
                {{ data.item.date ? formatDate(data.item.date, data.item.date_end) : '' }}
              </template>
              <template #cell(departure)="data">
                <person-inline v-if="data.item.author" :value="data.item.author"></person-inline>
                <div class="badge badge-soft-secondary text-primary" v-if="data.item.location_departure">
                  {{ data.item.location_departure }}
                </div>
              </template>
              <template #cell(destination)="data">
                <person-inline v-if="data.item.recipient" :value="data.item.recipient"></person-inline>
                <div class="badge badge-soft-secondary text-primary" v-if="data.item.location_destination">
                  {{ data.item.location_destination }}
                </div>
              </template>
              <template #cell(attachment)="data">
                <i class="bx bx-paperclip label-icon" v-if="data.item.attachment !== ''"></i>
              </template>
              <template #cell(letter_type)="data">
                {{ data.item.letter_type ? capitalizeFirstLetter(data.item.letter_type.name) : '' }}
              </template>
              <template #cell(format)="data">
                {{ data.item.document_type ? data.item.document_type.name : '' }}
              </template>

              <template #cell(persons)="data">
                <template v-for="(person, i) in data.item.persons">
                  <person-inline :value="person" :key="i"></person-inline>
                </template>
              </template>
            </b-table>

            <pagination-local v-model="currentPageCorrespondences" :total="correspondancesTotal"></pagination-local>
          </b-tab>

          <b-tab title="Pages" no-body @click="clickedPages = true">
            <b-table v-if="clickedPages" :items="providerPages" :fields="pageFields" responsive="sm" striped sticky-header :per-page="10"
                     head-variant="light" :current-page="currentPagePages">
              <template #table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>

              <template #cell(NumPageAlbum)="data">
                <b>{{ data.item.NumPageAlbum }}</b>

                <span v-if="isBis(data.item)" role="button" class="badge bg-info font-size-11 m-1 float-end">
            BIS
        </span>

                <div v-for="(inventory, i) in data.item.inventories" :key="i">
          <span role="button" @click="displayInventoryDetails = true; displayedInventory = inventory"
                class="badge badge-soft-info">{{ inventory.inventory_number }}</span>
                </div>
              </template>

              <template #cell(image)="data">
                <div v-if="data.item.image_available" @click="clickedImage(getImagePath(data.item))"
                     class="hover-cursor-pointer">
                  <b-img-lazy :key="data.item.CodePageAlbum" :src="getImagePath(data.item, true)[0].src"
                              :alt="data.item.NumPageAlbum"/>
                </div>
              </template>

              <template #cell(date)="data">
                <div>{{ formatDate(data.item) }}</div>
                <div v-if="data.item.DetailDate !== ' '"><small>{{ data.item.DetailDate }}</small></div>
              </template>

              <template #cell(address)="data">
                {{ formatAdresse(data.item) }}
              </template>

              <template #cell(inscription_commentaire)="data">
                <div v-if="data.item.Inscription !== '' && data.item.Inscription !== ' '"><strong>Inscription
                  : </strong>
                  {{ data.item.Inscription }}
                </div>
                <div v-if="data.item.Commentaire !== '' && data.item.Commentaire !== ' '"><strong>Commentaire
                  : </strong>
                  {{ data.item.Commentaire }}
                </div>
              </template>

              <template #cell(persons)="data">
                <template v-for="person in data.item.persons">
                  <person-inline :value="person" :key="person.id"></person-inline>
                </template>
              </template>
            </b-table>

            <pagination-local v-model="currentPagePages" :total="pagesTotal"></pagination-local>
          </b-tab>

          <b-tab title="Négatifs" @click="clickedInventories = true">
            <b-table v-if="clickedInventories" :items="providerInventories" :fields="inventoryFields" responsive="sm" striped sticky-header :per-page="10"
                     head-variant="light" :current-page="currentPageInventories">
              <template #table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>

              <template #cell(exploitation_number)="data">
                <span class="badge bg-info">{{ data.item.exploitation_number }}</span>
              </template>

              <template #cell(title)="data">
                <span :title="data.item.title">{{ truncate(data.item.title, 50, '...') }}</span>
              </template>

              <template #cell(address)="data">
                {{ data.item.address ? formatAddress(data.item.address) : '' }}
              </template>

              <template #cell(date)="data">
                <div v-html="formatDate(data.item.date, data.item.date_end)"></div>
              </template>

              <template #cell(support)="data">
                  <span class="badge bg-secondary text-primary">{{
                      data.item.support ? data.item.support.title : ''
                    }}</span>
              </template>

              <template #cell(authors)="data">
                <template v-for="(person, i) in data.item.authors">
                  <person-inline :value="person" :key="i"></person-inline>
                </template>
              </template>

              <template #cell(persons)="data">
                <template v-for="(person, i) in data.item.persons">
                  <person-inline :value="person" :key="i"></person-inline>
                </template>
              </template>

              <template #cell(format)="data">
                  <span class="badge bg-secondary text-primary">{{
                      data.item.format ? data.item.format.string : ''
                    }}</span>
              </template>
            </b-table>

            <pagination-local v-model="currentPageInventories" :total="inventoriesTotal"></pagination-local>
          </b-tab>

          <b-tab title="Dessins & Peintures" @click="clickedDrawings = true">
            <b-table v-if="clickedDrawings" :items="providerDrawings" :fields="drawingFields" :with-delete-action="false" :with-edit-action="false"
                     :per-page="10" :current-page="currentPageDrawings">
              <template #table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              
              <template #cell(inventory_number)="data">
                {{ data.item.number }}
              </template>

              <template #cell(exploitation_number)="data">
                <span class="badge bg-info">{{ data.item.exploitation_number }}</span>
              </template>

              <template #cell(title)="data">
                <span :title="data.item.title">{{ truncate(data.item.title, 50, '...') }}</span>
              </template>

              <template #cell(address)="data">
                {{ data.item.address ? formatAddress(data.item.address) : '' }}
              </template>

              <template #cell(support)="data">
                  <span class="badge bg-secondary text-primary">
                    {{ data.item.support ? data.item.support.title : '' }}
                  </span>
              </template>

              <template #cell(authors)="data">
                <template v-for="(person, i) in data.item.authors">
                  <person-inline :value="person" :key="i"></person-inline>
                </template>
              </template>

              <template #cell(persons)="data">
                <template v-for="(person, i) in data.item.persons">
                  <person-inline :value="person" :key="i"></person-inline>
                </template>
              </template>

              <template #cell(format)="data">
                  <span class="badge bg-secondary text-primary">
                    {{ data.item.format ? data.item.format.string : '' }}
                  </span>
              </template>
            </b-table>

            <pagination-local v-model="currentPageDrawings" :total="drawingsTotal"></pagination-local>
          </b-tab>

          <b-tab title="Carnets">
            <b-table ref="notebooks" :items="notebooks" :fields="notebookFields" responsive="sm" hover striped
                     :per-page="notebooksPerPage" :current-page="notebooksCurrentPage" thead-class="text-capitalize"
                     table-class="mb-0" @row-clicked="showModel" class="table-image">
              <template #cell(image)="data">
                <b-card-img :src="getImagePathRoute('notebooks', data.item)[0].src" class="img-fluid"
                            style="width: 100px"></b-card-img>
              </template>
            </b-table>

            <pagination-local v-model="notebooksCurrentPage" :total="notebooks.length"></pagination-local>
          </b-tab>

          <b-tab title="Journaux">
            <b-table ref="newspapers" :items="newspapers" :fields="newspaperFields" responsive="sm" hover striped
                     :per-page="10" :current-page="currentPageNewspapers" thead-class="text-capitalize"
                     table-class="mb-0" @row-clicked="showModel" class="table-image">
              <template #cell(image)="data">
                <div @click="clickedImage(getImagePathRoute('newspapers', data.item, false))"
                     class="hover-cursor-pointer">
                  <b-card-img :src="getImagePathRoute('newspapers', data.item)[0].src" class="img-fluid"
                              style="width: 100px"></b-card-img>
                </div>
              </template>
            </b-table>

            <pagination-local v-model="currentPageNewspapers" :total="newspapers.length"></pagination-local>
          </b-tab>
        </b-tabs>
      </b-card-body>
    </template>

    <vue-easy-lightbox :visible="singleImage" :imgs="lightboxImgs" @hide="singleImage = false"></vue-easy-lightbox>
  </b-card>
</template>
